export const T = {
  en_GB: {
    noGoalAvailable: "No goal available for this form.",
  },
  nb_NO: {
    noGoalAvailable: "Ingen mål tilgjengelig for dette skjemaet.",
  },
} as const;
